<template>
  <div>
    <h1 class="text-h4 mb-4">Unbebaute Flächen suchen</h1>

    <v-skeleton-loader v-if="loading" type="paragraph, card, button" class="mb-4" />

    <template v-else>
      <v-card>
        <v-card-text>
          <v-text-field
            label="Bezeichnung"
            v-model="report.name"
          />

          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                label="Fläche min (m²)"
                type="number"
                v-model="report.constraints.area.min"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Fläche max (m²)"
                type="number"
                v-model="report.constraints.area.max"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Mindestabstand (m)"
                type="number"
                v-model="report.constraints.area.gap"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <small>Gebiet auswählen</small>
              <DistrictSelect v-model="report.constraints.district_id" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>


      <v-expansion-panels class="mt-1">
        <v-expansion-panel>
          <v-expansion-panel-title>
            Experteneinstellungen
          </v-expansion-panel-title>

          <v-expansion-panel-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Bounding Box von"
                  v-model="report.constraints.bounding_box.latlong1"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Bounding Box bis"
                  v-model="report.constraints.bounding_box.latlong2"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Flächen-Systemlimit"
                  type="number"
                  v-model="report.constraints.limits.area"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Lücken-Systemlimit"
                  type="number"
                  v-model="report.constraints.limits.gap"
                />
              </v-col>
            </v-row>

          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-btn type="submit" class="mt-4" color="primary" @click="createReport">Suche starten</v-btn>
    </template>
  </div>
</template>

<script setup>
  import DistrictSelect from "../components/report/DistrictSelect.vue";
  import { ref, onMounted } from "vue";
  import { useCommandStore } from "../stores/command";
  import { useFlashStore } from "../stores/flash";

  const report = ref({});
  const loading = ref(true);
  const flash = useFlashStore();
  const command = useCommandStore();

  onMounted(fillInDefaults);

  async function fillInDefaults() {
    const result = await command.execute("Reporting::Report", "defaults");
    if (result.success) {
      report.value = result.data;
    } else {
      flash.error(result.error);
    }
    loading.value = false;
  }

  async function createReport() {
    const result = await command.execute("Reporting::Report", "create", {
      reporting_report: report.value,
    });
    if (result.success) {
      window.location.href = `/reporting/reports/${result.data.id}`;
    } else {
      result.errors.forEach(flash.error);
    }
  }
</script>
